import { For, Show, createMemo, createSignal } from 'solid-js';
import useWidgetData from './useWidgetData.js';
import AdminSales from './AdminSales.jsx';
import PlayerTracking from './PlayerTracking.jsx';
import GuildAudit from './GuildAudit.jsx';
import wm from '../lib/wmStore.js';

const VIEWS = [
  { key: 'sales', label: '💰 Guild Sales' },
  { key: 'players', label: '👥 Member Roster & Dues' },
  { key: 'guilds', label: '⚔️ Guild Health & Bidding' },
];

function normalizeView(value, widgetType) {
  if (VIEWS.some(item => item.key === value)) return value;
  if (widgetType === 'guild-tracking' || widgetType === 'redfur-audit' || widgetType === 'guild-audit') return 'guilds';
  if (widgetType === 'member-auditing' || widgetType === 'player-tracking') return 'players';
  return 'sales';
}

export default function Auditing(props) {
  const [view, setViewRaw] = createSignal(normalizeView(props.settings?.view, props.widget?.type));
  const setView = value => {
    const next = normalizeView(value);
    setViewRaw(next);
    const wid = props.widget?.id;
    if (wid) {
      wm.setSettings(wid, { ...(props.widget?.settings || {}), view: next });
    }
  };
  const { loading, error } = useWidgetData('auditing', () => ({ view: view() }));
  const panelLabel = createMemo(() => VIEWS.find(item => item.key === view())?.label || 'Sales');

  return (
    <div class="v2-widget v2-auditing">
      <div class="v2-tabs" role="tablist" aria-label="Auditing views" aria-busy={loading() ? 'true' : 'false'}>
        <For each={VIEWS}>{item => (
          <button
            type="button"
            role="tab"
            aria-selected={view() === item.key}
            class={`v2-tab ${view() === item.key ? 'is-active' : ''}`}
            onClick={() => setView(item.key)}
          >
            {item.label}
          </button>
        )}</For>
        <span class="v2-dim" style={{ 'margin-left': 'auto', 'align-self': 'center', 'font-size': '10px' }}>
          {panelLabel()}
        </span>
      </div>
      <Show when={error()}>
        <div class="v2-error">{error()}</div>
      </Show>
      <div class="v2-auditing__body" style={{ flex: 1, 'min-height': 0 }}>
        <Show when={view() === 'sales'}><AdminSales widget={props.widget} settings={props.settings} /></Show>
        <Show when={view() === 'players'}><PlayerTracking widget={props.widget} settings={props.settings} /></Show>
        <Show when={view() === 'guilds'}><GuildAudit widget={props.widget} settings={props.settings} /></Show>
      </div>
    </div>
  );
}
